import { render, staticRenderFns } from "./OMSRuleQueueEventLogs.vue?vue&type=template&id=72394745"
import script from "./OMSRuleQueueEventLogs.vue?vue&type=script&lang=js"
export * from "./OMSRuleQueueEventLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports